import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ModalConfirmableComponent} from './modal-confirmable.component';
import {ButtonModule} from "../../buttons/button/button.module";


@NgModule({
  declarations: [
    ModalConfirmableComponent
  ],
  exports: [
    ModalConfirmableComponent
  ],
  imports: [
    CommonModule,
    ButtonModule
  ]
})
export class ModalConfirmableModule {
}
